import { simpleOrganizationFragment } from './fragmentsOrganization';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const organizationCreateMutationAtom = createMutationAtomFactory(
  'admin.organizationCreate',
  (params: {
    name: string;
    domain: string;
    timezone?: string;
    idpId?: string;
  }) => ({
    coreOrganizationCreate: {
      __args: {
        input: {
          name: params.name,
          domain: params.domain,
          timezone: params.timezone,
          idpId: params.idpId,
        },
      },
      ...simpleOrganizationFragment,
    },
  }),
);
